import { pageTitle } from 'ember-page-title';

<template>
  {{pageTitle "Coachee"}}
  <div class="container py-5">
    <div class="alert alert-danger" role="alert">
      You are not registered as a coachee. If you believe this is an error,
      please email
      <a href="mailto:v-support@hultashridge.com">v-support@hultashridge.com</a>
    </div>
  </div>
</template>
